import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  LiveChatEndReason,
  MessageSubType,
  MessageType,
} from '../../types/enum';
import { HttpErrorResponse } from '@angular/common/http';

export const MessagesActions = createActionGroup({
  source: 'Messages',
  events: {
    'Add New Messages': props<{ messages: Message[]; donNotSave?: boolean }>(),
    'Save Messages': props<{ messages: Message[] }>(),
    'Add Post Escalation Message Selection': props<{
      postEscalationSelection: PostEscalationSelection;
    }>(),
    'Update Live Chat System Message': props<{
      text: string;
      queuePosition: string;
      estimatedTime: string;
    }>(),
    'Add Plain System Message': props<{
      messageId?: string;
      text: string;
      messageSubtype?: MessageSubType;
    }>(),
    'Add End Of Chat Message': props<{ reason: LiveChatEndReason }>(),
    'Remove Last N Messages': props<{ numberOfItems: number }>(),
    'Update Last Message': props<{ updatedMessage: Message }>(),
    'Check For Quick Reply': props<{ userMessage: Message }>(),
    'Update Quick Reply': props<{
      updatedMessage: Message;
      userMessage: Message;
    }>(),
    'Handle User Message': props<{ query: string }>(),
    'Call Dialog Api': props<{ query: string }>(),
    'Dialog Api Success': props<{ messages: Message[] }>(),
    'Dialog Api Failed': emptyProps(),
    'On Dialog Api Failed': props<{ error: HttpErrorResponse }>(),
    'Add Messages With Delay': props<{
      messages: Message[];
      index: number;
      delay: number;
    }>(),
    'Clear Message Container': emptyProps(),
    'Handle Clickable Link': props<{
      bubbleEvent;
    }>(),
    'Handle Canned Response': props<{
      response: CannedResponse;
    }>(),
    'Ask User To Login': emptyProps(),
    'On Va False Canned Response Click': props<{
      response: CannedResponse;
    }>(),
    'Add Simple Dialog Message': props<{
      messageId?: string;
      messageText: string;
      messageType: MessageType;
      operatorName?: string;
      messageSubType?: string;
    }>(),
    'Create Wait For Connection Message': emptyProps(),
  },
});
